<template>

  <div
    class="feed-content"
    :class="{'box-loading': loading}">

    <div class="photo">
      <Avatar
        :src="imgSrc"
        :name="activity.candidate.name"
        size="40px"
        radius="20px"
        resize="100x100x1" />
    </div>
    
    <div class="content">
      
      <div
        v-if="permissions.includes('manage_candidates')"
        class="feed-actions dropdown">
        <button
          class="btn btn-sm btn-light"
          type="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false">
          <i class="fas fa-chevron-down" />
        </button>
        <div class="dropdown-menu dropdown-menu-right">
          <button
            class="dropdown-item"
            @click="deleteIntervideo(activity.intervideo._id)">
              <i class="fas fa-times" /> {{ $t('Remove') }}
            </button>
        </div>
      </div>

      <div>
        Vídeo entrevista <strong>{{ activity.intervideo.name }}</strong> respondido
      </div>
      
      <div class="mt-2">
        <strong>Média de avaliação:</strong> {{ activity.intervideo.avg_rating }}
      </div>

      <div
        v-if="showAll"
        class="card mt-2">
        <div 
          v-for="(question, index) in activity.intervideo.questions"
          :key="index">
          <div class="card-header">
            {{ question.label }}
          </div>
          <div class="card-body">
            <div class="mb-2">
              <ziggeo-player
                v-if="question.video_token"
                apiKey="5101684462d7b803779f705987566b35"
                :video="question.video_token"
                theme="minimalist"
                width="100%"
                height="auto">
                </ziggeo-player>
            </div>
            <candidate-feed-intervideo-item-rating
              :intervideo_id="activity.intervideo._id"
              :question_id="question._id"
              :ratings="ratings"
              @updated="updatedRating">
              </candidate-feed-intervideo-item-rating>
          </div>
        </div>
      </div>

      <div class="mt-2">
        <a href="javascript:void(0)" @click="showAll=!showAll">{{ showAll ? $t('Show less') : $t('Show more') }}</a>
      </div>

      <div class="mt-2">
        <small>
          <span
            v-tooltip="$d(new Date(activity.created_at), 'long')">
            {{ $d(new Date(activity.created_at), 'short') }}
            </span>
          <span>
            -
            </span> 
          <router-link
            class="link-discreet"
            :to="{path: '/job/' + activity.job._id }">
            {{ activity.job.title }}
            </router-link>
        </small>
      </div>
    </div>

  </div>

</template>

<script>
import config from '@/config'
import CandidateFeedIntervideoItemRating from './CandidateFeedIntervideoItemRating'
import Avatar from '@/components/Parts/Avatar'

export default {
  name: 'CandidateFeedIntervideoItem',
  components: {
    CandidateFeedIntervideoItemRating,
    Avatar
  },
  props: [
    'activity'
  ],
  data () {
    return {
      loading: false,
      showAll: false,
      ratings: []
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.getPermissions
    },
    imgSrc () {
      const defaultImageUrl = config.default_image_url.candidate
      const url = this.activity.candidate.photo_media_url
      return url && !url.includes(defaultImageUrl) ? url : null
    }
  },
  created () {
    this.loadRatings()
  },
  methods: {
    loadRatings () {
      this.$store
      .dispatch('getIntervideoRatings', {
        intervideo_id: this.activity.intervideo._id
      })
      .then((result) => {
        this.ratings = result
      })
    },
    updatedRating () {
      this.$store
      .dispatch('getActivities', {
        _id: this.activity._id
      })
      .then((aa) => {
        this.loadRatings()
      })
    },
    deleteIntervideo (id) {
      const deleteAction = () => {
        this.loading = true

        this.$store
        .dispatch('deleteIntervideo', id)
        .then((result) => {
          return this.$store.dispatch('deleteActivity', this.activity._id)
        })
        .then((result) => {
          this.loading = false
          this.$emit('deleted', result)
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: deleteAction
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .video-box{
    width: 100%;
    min-height: 200px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Candidate/Feed/CandidateFeedIntervideoItem.vue